import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryCommercialFeed = () => {
  return <CategoryBase baseEndpoint="category_commercial_feed" />;
};

export default CategoryCommercialFeed;
